/* eslint-disable */

import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import Api from "./Api";
import PARSE from "html-react-parser";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import clsxm from "../../context/clsxm";

const api = new Api();

export default function SSoft_Line_Services() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [listLine, setListLine] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }
            case 1: {
              setListLine(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <div className=" w-full relative md:py-[96px] py-[20px]  ">
      <div className="">
        <div className="section-container section-margin-x ">
          <h1 className="hd2xl:text-[36px] text-[32px] font-bold text-center pb-[53px]">
            {title?.content}
          </h1>

          <div className="flex flex-col h-full w-full items-center ">
            {listLine?.map((line, index) => {
              return (
                <div
                  className={clsxm(
                    " w-full  flex justify-start hd2xl:max-h-[450px] lg:max-h-[373px] max-h-full  mb-[40px] shadow-lg",
                    index % 2 === 0
                      ? "lg:flex-row flex-col bg-[#FAF8F5]"
                      : "lg:flex-row-reverse flex-col "
                  )}
                >
                  <div className="lg:w-6/12 w-fulll hd2xl:max-h-full lg:max-h-[350px]">
                    <img
                      src={line?.assets[0]?.file_medium}
                      alt=""
                      className=""
                    />
                  </div>
                  <div
                    className={clsxm(
                      "lg:w-6/12 w-fulll flex flex-col justify-center lg:py-16 py-[45px]"
                    )}
                  >
                    <div
                      className={clsxm(
                        "",
                        index % 2 === 0
                          ? "ml-auto lg:px-[80px] px-8"
                          : "lg:px-[65px] px-8"
                      )}
                    >
                      <h1 className="hd2xl:max-w-[300px] lg:max-w-[263px] text-[24px] hd2xl:text-[26px] fhd:text-[28px]  font-semibold">
                        {/* ini di update typo style */}
                        {line?.article_language?.title}
                      </h1>
                      {line?.article_language?.content && (
                        <h3 className="prose-p:text-[16px] hd2xl:prose-p:text-[20px] fhd:prose-p:text-[22px]  pt-[15px] fhd:max-w-[530px] hd2xl:max-w-[430px] lg:max-w-[387px] prose">
                          {PARSE(line?.article_language?.content || "")}
                        </h3>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="section-container section-margin-x">
      <Skeleton
        width={"100%"}
        className=" lg:h-[373px] s:h-[600px] h-[700px]"
      />
    </div>
  );
}
